import React from 'react';

import FalconsHeaderAdapter from './FalconsHeaderAdapter';
import LandingHeaderAdapter from './LandingHeaderAdapter';
import LifeCareerBalanceHeaderAdapter from './LifeCareerBalanceHeaderAdapter';
import StandardHeaderAdapter from './StandardHeaderAdapter';

interface HeaderAdapterProps {
  isFalconsPage: boolean;
  isLcbPage: boolean;
  isLcbApplyNowPage: boolean;
  isLandingPage: boolean;
}

const HeaderAdapter: React.FC<HeaderAdapterProps> = ({
  isFalconsPage,
  isLcbPage,
  isLcbApplyNowPage,
  isLandingPage,
}) => {
  if (isFalconsPage) {
    return <FalconsHeaderAdapter />;
  } else if (isLandingPage) {
    return <LandingHeaderAdapter />;
  } else if (isLcbPage) {
    return <LifeCareerBalanceHeaderAdapter isApplyNow={isLcbApplyNowPage} />;
  }
  return <StandardHeaderAdapter />;
};

export default HeaderAdapter;
